import { useState, useEffect } from 'react';
import throttle from 'lodash.throttle';

const getDeviceConfig = (width) => {
  if (width < 640) {
    return 'sm';
  } else if (width >= 640 && width < 768) {
    return 'md';
  } else if (width >= 768 && width < 1024) {
    return 'lg';
  } else if (width >= 1024 && width < 1536) {
    return 'xl';
  } else if (width >= 1536) {
    return '2xl';
  }
};

export const useBreakpoint = () => {
  const [brkPnt, setBrkPnt] = useState(() =>
    getDeviceConfig(window.innerWidth)
  );

  useEffect(() => {
    const calcInnerWidth = throttle(function () {
      setBrkPnt(getDeviceConfig(window.innerWidth));
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  return brkPnt;
};
